import { render, staticRenderFns } from "./ProofOfAddress.vue?vue&type=template&id=c580f0de&scoped=true&"
import script from "./ProofOfAddress.vue?vue&type=script&lang=js&"
export * from "./ProofOfAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c580f0de",
  null
  
)

export default component.exports